import { render, staticRenderFns } from "./SolutionDataCenter.vue?vue&type=template&id=5139b5e6&scoped=true&"
import script from "./SolutionDataCenter.vue?vue&type=script&lang=js&"
export * from "./SolutionDataCenter.vue?vue&type=script&lang=js&"
import style0 from "./SolutionDataCenter.vue?vue&type=style&index=0&id=5139b5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5139b5e6",
  null
  
)

export default component.exports